import React, { useState } from "react";
import Styled from "styled-components";

import { ITheme, TStyledPropTheme } from "../../interface";
import { useTheme } from "../../context/ThemeProvider";
import { themes } from "../../constant";

import iconSun from "../../assets/images/sun.svg";
import iconMoon from "../../assets/images/moon.svg";

const Nav = Styled.nav<TStyledPropTheme>(({ $props }: TStyledPropTheme) => ({
  transition: "all 0.8s ease-in-out",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "sticky",
  top: 0,
  zIndex: 10,
  height: "5vh",
  padding: "2.5vh 3vw",
}));

const NavBarContainer = Styled.div`
  display: flex;
  justify-content: space-between;
`;

const ThemeButton = Styled.div<{ $props: ITheme }>(
  ({ $props }: { $props: ITheme }) => {
    const quarternaryColor = $props.colors.quarternary;

    return {
      transition: "all 0.4s ease-in-out 0s",
      display: "flex",
      alignItems: "center",
      height: "35px",
      width: "35px",
      backgroundColor:
        $props.name === "light"
          ? themes.dark.colors.primary
          : themes.light.colors.primary,
      justifyContent: "center",
      textAlign: "center",
      borderRadius: "25%",
      cursor: "pointer",
      boxShadow: `${quarternaryColor} 0px 5px 27px -5px, ${quarternaryColor} 0px 8px 16px -8px`,
    };
  }
);

const ThemeIcon = Styled.img<{ $props: ITheme & { active: boolean } }>(
  ({ $props }: { $props: ITheme & { active: boolean } }) => {
    return {
      transform: `scale(${$props.active ? 1 : 0}) rotate(${
        $props.active ? 360 : 0
      }deg)`,
      transition: `all 0.4s ease-in-out ${$props.active ? 0.2 : 0}s`,
      position: "absolute",
    };
  }
);

function NavBar() {
  const { theme, toggleTheme } = useTheme();
  const isCurrentDark = theme.name === "dark";
  const [darkActive, setDarkActive] = useState(isCurrentDark);
  const [lightActive, setLightActive] = useState(!isCurrentDark);

  return (
    <Nav $props={{ colorTheme: theme.colors }}>
      <NavBarContainer>
        <ThemeButton
          $props={theme}
          onClick={() => {
            toggleTheme(isCurrentDark ? themes.light : themes.dark);
            setDarkActive(!isCurrentDark);
            setLightActive(isCurrentDark);
          }}
        >
          <ThemeIcon
            $props={{ ...theme, active: darkActive }}
            src={iconSun}
            sizes="40"
          />
          <ThemeIcon
            $props={{ ...theme, active: lightActive }}
            src={iconMoon}
            sizes="40"
          />
        </ThemeButton>
      </NavBarContainer>
    </Nav>
  );
}

export default NavBar;
